module.exports = __webpack_public_path__ + "static/media/skype-social-media-svgrepo-com.1f088184.svg";